import PropTypes from 'prop-types';
import React from 'react';

import './TextBox.css';

function TextBox(_ref) {
  var text = _ref.text,
      css = _ref.css;

  return React.createElement(
    'div',
    { className: 'TextBox', style: css || {} },
    text
  );
}

TextBox.propTypes = process.env.NODE_ENV !== "production" ? {
  css: PropTypes.object,
  text: PropTypes.string.isRequired
} : {};

export default TextBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/TextBox.js
// module id = 723
// module chunks = 0